// const [deviceFormData, setDeviceFormData] = React.useState({
//     brand: "",
//     company: "",
//     dataProtocol: "",
//     description: "",
//     id: "",
//     model: "",
//     password: "",
//     software: "",
//     softwareVersion: "",
//     status: "ACTIVE",
// });

export const device_fields = () => [
  // {
  //   key: 'id',
  //   type: 'text',
  //   inputType: 'text',
  //   placeHolder: 'ID*',
  //   defaultValue: '',
  // },
  {
    key: 'imei',
    type: 'text',
    inputType: 'text',
    placeHolder: 'IMEI*',
    defaultValue: '',
  },
  {
    key: 'status',
    type: 'select',
    items: [
      { value: 'ACTIVE', text: 'Aktif' },
      { value: 'INACTIVE', text: 'Pasif' },
    ],
    placeHolder: 'Durum*',
    defaultValue: 'ACTIVE',
  },
  {
    key: 'barcodeNumber',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Barkod Numarası',
    defaultValue: '',
  },
  {
    key: 'deviceModel',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Cihaz Modeli',
    defaultValue: '',
  },
  {
    key: 'description',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Açıklama',
    defaultValue: '',
  },
  {
    key: 'version',
    type: 'text',
    inputType: 'text',
    placeHolder: 'Versiyon',
    defaultValue: '',
  },
];
